export function resolveFirebaseAuthEmulatorUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined
  const candidate = value.trim()
  if (!candidate || /^\$[A-Z0-9_]+$/.test(candidate)) return undefined

  let url: URL
  try {
    url = new URL(candidate)
  }
  catch {
    throw new Error('Firebase Auth emulator URL must be an absolute URL')
  }
  if (url.protocol !== 'http:') {
    throw new Error('Firebase Auth emulator URL must use http://')
  }
  if (!url.hostname || !url.port || url.pathname !== '/' || url.search || url.hash) {
    throw new Error('Firebase Auth emulator URL must contain only an http host and port')
  }
  return url.origin
}

export function resolveFirebaseAuthEmulatorConfig(
  value: unknown,
  e2eEnabled: boolean,
): string | undefined {
  const url = resolveFirebaseAuthEmulatorUrl(value)
  if (url && !e2eEnabled) {
    throw new Error('FIREBASE_AUTH_EMULATOR_URL may only be set with QUTEE_E2E=1')
  }
  return url
}

export function validateFirebaseE2EProjectId(
  value: unknown,
  e2eEnabled: boolean,
): void {
  if (!e2eEnabled) return
  if (typeof value !== 'string' || value.trim() !== 'demo-qutee-e2e') {
    throw new Error('QUTEE_E2E requires FIREBASE_PROJECT_ID=demo-qutee-e2e')
  }
}
